export default function apiStatusReducer(state = {}, action) {
  const { type } = action;

  const statusActionType = type.substr(0, type.lastIndexOf('_'));

  if (type.endsWith('_REQUEST')) {
    return {
      ...state,
      [statusActionType]: {
        isRequested: true,
        isLoading: true,
        success: false,
        error: null
      }
    };
  } else if (type.endsWith('_SUCCESS')) {
    return {
      ...state,
      [statusActionType]: {
        isRequested: true,
        isLoading: false,
        success: true,
        error: null
      }
    };
  } else if (type.endsWith('_FAILURE')) {
    return {
      ...state,
      [statusActionType]: {
        isRequested: true,
        isLoading: false,
        success: false,
        error: action.payload
      }
    };
  }

  if (type === '@@router/LOCATION_CHANGE') {
    return {};
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/store/apiStatus/reducer.js